import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useSelector } from 'react-redux';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import ProductsTable from '../components/ProductsTable';
import ProductsListPageActions from '../components/ProductsListPageActions';
import ProductsListFilters from '../components/ProductsListFilters';
import useProductFilters from '../../../components/filters/ProductsFilterHelper';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

function ProductListPage() {
  const { products: p } = useTranslatedMessages();
  const listT = p.pages?.list ?? {};
  useDocumentTitle(listT.document_title ?? 'Product List');
  const user = useSelector((state) => state.user.user);

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'name',
          placeholder: listT.filters?.placeholders?.name ?? 'Name',
        },
      ],
    },
  ];

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  } = useProductFilters({ persistKey: 'products' });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <TopBar title={listT.top_bar_title ?? 'Products/Services'}>
        <ProductsListPageActions />
      </TopBar>
      <Box mb={2}>
        <ProductsListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          searchTerm={searchTerm}
          searchPlaceholder={listT.filters?.search_placeholder}
        />
      </Box>
      <ProductsTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default ProductListPage;
